import React from "react";
import { useSelector } from "react-redux";
import {
    getDefaultHeightOfPaymentIframe,
    getIdOfPaymentIframe,
    getIdOfPaymentIframeContainer,
    getUrlOfPaymentIframe,
    PaymentIframe,
} from "@qgiv/core-react";
import { selectConfig } from "../../../../redux/slices/configSettingsSlice";
import { selectHasBillingNameField } from "../../../../redux/slices/fieldsSlice";
import { selectAllFormSettings } from "../../../../redux/slices/formSettingsSlice";

/**
 * @returns {React.ReactElement}
 */
const ConnectedPaymentIframe = () => {
    const config = useSelector(selectConfig);
    const formSettings = useSelector(selectAllFormSettings);
    const billingNameField = useSelector(selectHasBillingNameField);
    const { isCms, QGIV_HOST } = config;
    const { id } = formSettings;

    // Format data for use in helper functions and props
    const hasBillingNameField = !!billingNameField?.exists;
    const formId = id;

    const defaultHeightOfPaymentIframe =
        getDefaultHeightOfPaymentIframe(hasBillingNameField);
    const idOfPaymentIframe = getIdOfPaymentIframe();
    const idOfPaymentIframeContainer = getIdOfPaymentIframeContainer();
    const originOfPaymentIframe = QGIV_HOST;
    const urlOfPaymentIframe = getUrlOfPaymentIframe({
        formId,
        isCms,
        originOfPaymentIframe,
    });

    const paymentIframeProps = {
        defaultHeightOfPaymentIframe,
        idOfPaymentIframe,
        idOfPaymentIframeContainer,
        urlOfPaymentIframe,
        originOfPaymentIframe,
    };

    return <PaymentIframe {...paymentIframeProps} />;
};

export default ConnectedPaymentIframe;
